import type { ChatIntegrationProvider, IChatIntegrations } from '@interfaces/IChatIntegrations';

/** Every chat app, in the order the popover lists them. */
export const CHAT_INTEGRATION_PROVIDERS: readonly ChatIntegrationProvider[] = ['slack', 'teams', 'googleChat', 'whatsapp'];

/** Every app, none connectable: what the popover shows until the server answers. */
export const ALL_COMING_SOON: IChatIntegrations = {
  apps: CHAT_INTEGRATION_PROVIDERS.map((provider) => ({ provider, available: false, connection: null })),
};
